// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"586":"7ea6db7b","623":"5dfc72b1"}[chunkId] + ".chunk.css";
};